export default "__VITE_ASSET__BfkUP9vN__"